/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Harden_Detail6Inputs */

const en_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy, document and hand over.`)
};

const ar_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انشر ووثّق وسلّم.`)
};

const bn_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয় করুন, ডকুমেন্ট করুন আর হস্তান্তর করুন।`)
};

const de_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployen, dokumentieren und übergeben.`)
};

const es_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplegar, documentar y entregar.`)
};

const fr_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployez, documentez et transmettez.`)
};

const pt_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publique, documente e entregue.`)
};

const zh_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署、写文档、交接。`)
};

const tr_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayınlayın, belgeleyin, devredin.`)
};

const ru_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задеплойте, задокументируйте и передайте.`)
};

const pl_svc_ai_app_rescue_harden_detail6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdróż, udokumentuj i przekaż.`)
};

/**
* | output |
* | --- |
* | "Deploy, document and hand over." |
*
* @param {Svc_Ai_App_Rescue_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_harden_detail6 = /** @type {((inputs?: Svc_Ai_App_Rescue_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_harden_detail6(inputs)
	return en_svc_ai_app_rescue_harden_detail6(inputs)
});
export { svc_ai_app_rescue_harden_detail6 as "svc_ai-app-rescue_HARDEN_detail" }